import React from 'react';
import { VerticalIconMenu } from 'swag-client-common/components/ui/vertical-icon-menu';
import classes from './mobile-item-control.scss';
export function MobileItemControl({
  isEditPossible,
  removeBtnText,
  editBtnText,
  onEditClick,
  onMoveToCartClick,
  onRemoveClick,
  onShareClick,
  onMoveToDraftClick,
  isShareButtonAvailable,
  isAddToCardAvailable,
  isSaveForLaterAvailable,
  isRemoveItemAvailable
}) {
  return /*#__PURE__*/React.createElement(VerticalIconMenu, {
    className: classes.verticalMenu,
    buttonClassName: classes.button
  }, isEditPossible && /*#__PURE__*/React.createElement("div", {
    className: classes.contextMenuItem,
    "data-button": "Edit",
    onClick: onEditClick
  }, editBtnText), isAddToCardAvailable && /*#__PURE__*/React.createElement("div", {
    className: classes.contextMenuItem,
    "data-button": "MoveToCart",
    onClick: onMoveToCartClick
  }, "Add to cart"), isSaveForLaterAvailable && /*#__PURE__*/React.createElement("div", {
    className: classes.contextMenuItem,
    "data-button": "MoveToDraft",
    onClick: onMoveToDraftClick
  }, "Save for later"), isRemoveItemAvailable && /*#__PURE__*/React.createElement("div", {
    className: classes.contextMenuItem,
    "data-button": "Remove",
    onClick: onRemoveClick
  }, removeBtnText), isShareButtonAvailable && /*#__PURE__*/React.createElement("div", {
    className: classes.contextMenuItem,
    "data-button": "Share",
    onClick: onShareClick
  }, "Share"));
}